import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import { Route, Redirect } from 'react-router-dom';
import { getAuthenticationState, getAuthenticationStateOptions } from '../graphql';
import { renderForError, renderWhileLoading } from '../apollo';

class ProtectedRoute extends Component {
    render() {
        let { authenticationState } = this.props.authenticationState;
        let CustomComponent = this.props.component;

        return (
            <Route
                {...this.props}
                component={props => (
                    authenticationState.authenticated && authenticationState.accounts && authenticationState.accounts.length > 0
                    ? <CustomComponent {...props} />
                    : <Redirect to='/create' />
                )}
            />
        );
    }
}

export default compose(
    graphql(getAuthenticationState, getAuthenticationStateOptions),
    renderForError('authenticationState'),
    renderWhileLoading('authenticationState')
)(ProtectedRoute);